import { render, staticRenderFns } from "./Venus.vue?vue&type=template&id=68c2527d&"
import script from "./Venus.vue?vue&type=script&lang=js&"
export * from "./Venus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports